document.addEventListener('turbolinks:load', function() {
    var cpfInput = document.getElementById('cpf');
  
    if (cpfInput) {
      cpfInput.addEventListener('input', function(event) {
        var inputValue = event.target.value;

        var cleanedValue = inputValue.replace(/\D/g, '');

        var maxLength = 11;
        cleanedValue = cleanedValue.slice(0, maxLength);

        cpfInput.value = cleanedValue;
      });
    }
});
  